<template>
  <div></div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { fromLongToShort } from '@/components/shared/languageCodes';

export default {
  computed: {
    ...mapGetters({
      deviceName: 'device/deviceName',
      deviceToken: 'device/deviceToken',
      advertisingToken: 'device/advertisingToken',
      getLang: 'settings/getSiteLanguage',
      getSelectedLearnedLanguage: 'settings/getSelectedLearnedLanguage',
    }),
    mixinDevName() {
      return (
        this.deviceName !== undefined &&
        this.deviceName !== '' &&
        this.deviceName !== null
      );
    },
    mixinDevToken() {
      return (
        this.deviceToken !== undefined &&
        this.deviceToken !== '' &&
        this.deviceToken !== null
      );
    },
    mixinAdvToken() {
      return (
        this.advertisingToken !== undefined &&
        this.advertisingToken !== '' &&
        this.advertisingToken !== null
      );
    },
  },
  methods: {
    ...mapActions({
      setDeviceName: 'device/setDeviceName',
      setDeviceToken: 'device/setDeviceToken',
      setAdvertisingToken: 'device/setAdvertisingToken',
    }),
    async googleLoginMethod() {
      return new Promise((resolve, reject) => {
        const client = window.google.accounts.oauth2.initTokenClient({
          client_id: process.env.VUE_APP_GOOGLE_ID,
          scope: 'https://www.googleapis.com/auth/userinfo.profile',
          ux_mode: 'popup',
          callback: (response) => {
            const provider = 'google';
            const loginDetails = this.getUserLoginDetails(
              provider,
              response.access_token,
            );
            if (location.href.includes('login') || location.href.includes('register')) {
              this.decideUserNextStep(loginDetails, true);
            }
            resolve(loginDetails);
          },
          error_callback: () => {
            if (location.href.includes('login') || location.href.includes('register')) {
              this.isGoogleBtnLoading = false;
            } else {
              this.isAuthenticationRunning = false;
            }
            reject();
          },
        });
        client.requestAccessToken();
      });
    },
    generateDeviceInfoIfNeeded() {
      if (!this.mixinDevName || !this.mixinDevToken || !this.mixinAdvToken) {
        const userAgent = navigator.userAgent.substring(0, 230);
        const date = this.$moment().format('YYYY-MM-DD HH:mm');
        this.setDeviceName(`${userAgent} ${date}`);
        this.setDeviceToken(this.$uuid());
        this.setAdvertisingToken(this.$uuid());
      }
    },
    appleRedirectUri(redirectUri, changeAccount) {
      const redirectEnvUri = process.env.VUE_APP_APPLE_API_URL;
      // const testEnvUri = "http://localhost%3A8080/%23/register"
      const stateEnvUri =
        window.location.origin === 'http://localhost:8080'
          ? 'http://localhost%3A8080/%23'
          : window.location.origin;
      if (changeAccount) {
        return `https://appleid.apple.com/auth/authorize?client_id=eu.codeyard.XeropanWebLogin&redirect_uri=${redirectEnvUri}&state=${
          stateEnvUri + redirectUri
        }%3FfromChangeAccount=true&response_mode=form_post&response_type=code&scope=name email`;
      }
      return `https://appleid.apple.com/auth/authorize?client_id=eu.codeyard.XeropanWebLogin&redirect_uri=${redirectEnvUri}&state=${
        stateEnvUri + redirectUri
      }%3FfromChangeAccount=false&response_mode=form_post&response_type=code&scope=name email`;

      // return `https://appleid.apple.com/auth/authorize?client_id=eu.codeyard.XeropanWebLogin&redirect_uri=${redirectEnvUri}&state=${stateEnvUri + redirectUri}&response_mode=form_post&response_type=code&scope=name email`
    },
    getUserLanguage() {
      const lang = fromLongToShort[this.getLang];
      if (!lang) {
        return 'en';
      }
      return lang;
    },
    authenticateViaProvider(provider) {
      return new Promise((resolve, reject) => {
        this.hello(provider)
          .login({ scope: 'email, friends', force: true })
          .then(
            (response) => {
              const loginDetails = this.getUserLoginDetails(
                provider,
                response.authResponse.access_token,
              );
              resolve(loginDetails);
              // callback(loginDetails);
            },
            () => {
              reject();
              // const loginDetails = {
              //   hasError: true,
              // };
              // const inviterCode = localStorage.getItem('invitationCode');
              // if (inviterCode) loginDetails.inviter_code = inviterCode;
              // callback(loginDetails);
            },
          );
      });
    },
    authenticateViaApple(accessToken, name) {
      const loginDetails = this.getUserLoginDetails('apple', accessToken, name);
      // const loginDetails = {
      //   provider: "apple",
      //   access_token: accessToken,
      //   device_name: this.deviceName,
      //   device_token: this.deviceToken,
      //   advertising_token: this.advertisingToken,
      //   learned_language_id: this.getSelectedLearnedLanguage,
      //   country_code: this.getUserLanguage(),
      //   name
      // };

      return loginDetails;
    },
    getUserLoginDetails(
      provider = 'trial',
      accessToken = '',
      name = undefined,
    ) {
      const details = {
        provider,
        access_token: accessToken,
        device_name: this.deviceName,
        device_token: this.deviceToken,
        advertising_token: this.advertisingToken,
        // learned_language_id: this.getSelectedLearnedLanguage,
        learn_to_language_code: this.getSelectedLearnedLanguage,
        country_code: this.getUserLanguage(),
        learned_language_id: this.getSelectedLearnedLanguage,
      };
      if (name) details.name = name;

      const inviterCode = localStorage.getItem('invitationCode');
      if (inviterCode) details.inviter_code = inviterCode;

      return details;
    },
    setGdprOptions(details, options = { system: true, marketing: true }) {
      const loginDetails = details;
      loginDetails.opt_in_system = options.system;
      loginDetails.opt_in_marketing = options.marketing;
      return loginDetails;
    },
  },
};
</script>
